import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/leaderboard-up.svg'
import _imports_1 from '@/assets/img/Icons/leaderboard-down.svg'
import _imports_2 from '@/assets/img/Icons/linkicons/note.svg'
import _imports_3 from '@/assets/img/Icons/linkicons/workflow.svg'
import _imports_4 from '@/assets/img/Icons/linkicons/rewind_time.svg'
import _imports_5 from '@/assets/img/Icons/linkicons/shoutout.svg'


const _withScopeId = n => (_pushScopeId("data-v-303d7a5b"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "circle-container" }
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  src: _imports_0,
  alt: "green arrow pointing up"
}
const _hoisted_5 = {
  key: 1,
  src: _imports_1,
  alt: "red arrow pointing down"
}
const _hoisted_6 = { class: "number" }
const _hoisted_7 = { class: "right" }
const _hoisted_8 = {
  key: 0,
  style: {"font-style":"italic"}
}
const _hoisted_9 = {
  key: 0,
  class: "moderated-container--tag"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "/img/magic-wand.svg" }, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "uk-clearfix" }, null, -1))
const _hoisted_12 = { class: "user-info" }
const _hoisted_13 = { class: "name" }
const _hoisted_14 = {
  key: 0,
  class: "do-not-contact"
}
const _hoisted_15 = { class: "time-since" }
const _hoisted_16 = { class: "icons-left" }
const _hoisted_17 = ["title", "src"]
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = ["title"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  "data-uk-tooltip": "",
  title: "Send a Shoutout about this Response",
  alt: "Shoutout",
  src: _imports_5
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = {
  key: 0,
  class: "no-results"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = {
  key: 1,
  class: "no-results"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_NoticesComposer = _resolveComponent("NoticesComposer")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.displayResponses, (response) => {
        return (_openBlock(), _createElementBlock("div", {
          key: response.id,
          class: "response can-view-chat",
          onClick: ($event: any) => (_ctx.onClickResponse(response.id))
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", {
              class: _normalizeClass([_ctx.getCircleClass(response), "circle"])
            }, _toDisplayString(response.answer), 3),
            (_ctx.answerChange(response) != 0)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "answer-change",
                  "data-uk-tooltip": "{ pos: 'bottom' }",
                  title: `Previous ${_ctx.isFiveScore ? 'Rating' : 'NPS'} ${
                            response.previous_answer
                        }`
                }, [
                  (_ctx.answerChange(response) > 0)
                    ? (_openBlock(), _createElementBlock("img", _hoisted_4))
                    : (_ctx.answerChange(response) < 0)
                      ? (_openBlock(), _createElementBlock("img", _hoisted_5))
                      : _createCommentVNode("", true),
                  _createElementVNode("span", _hoisted_6, "  " + _toDisplayString(Math.abs(_ctx.answerChange(response))), 1)
                ], 8, _hoisted_3))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass(["comment", { 'render-newlines': _ctx.renderNewline }])
            }, [
              _createTextVNode(_toDisplayString(_ctx.getComment(response.comment)) + " ", 1),
              (!response.comment)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, " No comment "))
                : _createCommentVNode("", true)
            ], 2),
            (response.original_comment)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _hoisted_10,
                  _createTextVNode(" Moderated by NiceAI ")
                ]))
              : _createCommentVNode("", true),
            _hoisted_11,
            (_ctx.getShowBadges && !_ctx.hasSelectedBadge)
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(response.badges, (badge, idx) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: idx,
                    class: "badge",
                    style: _normalizeStyle(_ctx.getBadgeStyle(badge))
                  }, _toDisplayString(_ctx.getBadge(badge)), 5))
                }), 128))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("span", _hoisted_13, [
                (Boolean(Number(response?.dontcontact)))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_14, " (Do not contact) "))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.getResponseName(response)), 1)
              ]),
              _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.timeSinceResponded(response.responded)), 1)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass([
                            'status-icons',
                            {
                                'show-status-icon':
                                    _ctx.shouldShowStatusIconForResponse(response),
                            },
                        ])
            }, [
              _createElementVNode("div", _hoisted_16, [
                (response.chat_count)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      class: "icon",
                      "data-uk-tooltip": "",
                      title: `${response.chat_count} ${
                                    response.chat_count > 1
                                        ? 'Replies'
                                        : 'Reply'
                                }`,
                      src: _ctx.commentIcon(response.chat_outgoing)
                    }, null, 8, _hoisted_17))
                  : _createCommentVNode("", true),
                (
                                    _ctx.permissionList?.includes(
                                        'ROLE_VIEW_NOTES'
                                    ) && response.note_count
                                )
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 1,
                      class: "icon",
                      "data-uk-tooltip": "",
                      title: `${response.note_count} Note${
                                    response.note_count > 1 ? 's' : ''
                                }`,
                      src: _imports_2
                    }, null, 8, _hoisted_18))
                  : _createCommentVNode("", true),
                (response.automation_count)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 2,
                      class: "icon",
                      "data-uk-tooltip": "",
                      title: `${response.automation_count} Workflow${
                                    response.automation_count > 1 ? 's' : ''
                                }`,
                      src: _imports_3
                    }, null, 8, _hoisted_19))
                  : _createCommentVNode("", true),
                (response.response_count > 1)
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 3,
                      class: "icon",
                      "data-uk-tooltip": "",
                      title: `${response.response_count} Responses`,
                      src: _imports_4
                    }, null, 8, _hoisted_20))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.canSendShoutout(response))
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "shoutout-button",
                    onClick: _withModifiers(($event: any) => (_ctx.onClickShoutout(response)), ["stop"])
                  }, _hoisted_23, 8, _hoisted_21))
                : _createCommentVNode("", true)
            ], 2)
          ])
        ], 8, _hoisted_1))
      }), 128)),
      (
                    !_ctx.loading && (!_ctx.displayResponses || !_ctx.displayResponses.length)
                )
        ? (_openBlock(), _createElementBlock("div", _hoisted_24, " No Responses Found "))
        : _createCommentVNode("", true)
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createVNode(_component_Loading, {
            loading: _ctx.loading,
            contained: true
          }, null, 8, ["loading"])
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading && _ctx.resultsDepleted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_26, " No More Responses "))
      : _createCommentVNode("", true),
    (_ctx.shoutoutNoticeLoading)
      ? (_openBlock(), _createBlock(_component_Loading, {
          key: 2,
          loading: _ctx.shoutoutNoticeLoading,
          contained: ""
        }, null, 8, ["loading"]))
      : (_openBlock(), _createBlock(_component_NoticesComposer, {
          key: 3,
          "reset-on-show": "",
          show: _ctx.showNoticeComposer,
          "start-step": "message",
          onClose: _ctx.closeResponseShoutout,
          onNoticeSent: _ctx.closeResponseShoutout
        }, null, 8, ["show", "onClose", "onNoticeSent"]))
  ]))
}